import(/* webpackMode: "eager" */ "/Users/mac/development/web_projects/codigo/codigo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/codigo/src/app/products/components/CapStateDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/codigo/src/app/products/components/WislyDetail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/codigo/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/codigo/src/components/ui/AppLogo.tsx");
